import { Delete } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import EditIcon from "@mui/icons-material/Edit";
import useConfig from "../../../../../hooks/useConfig";
import HttpService from "../../../../../hooks/Https-services";
import PageRoutes, { APIRoutes } from "../../../../../utils/constants";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
const StatusBox = ({ data, handleRefresh }: any) => {
  const configData = useConfig();
  const navigate = useNavigate();
  const handleUnpublish = async (row: any) => {
    try {
      const payload = {
        game_id: row?.GameID,
        customer_id: row?.CustomerID,
      };
      const res = await HttpService.post(
        APIRoutes.UnPublishPoll.replace(":id", row?.ID),
        payload
      );

      handleRefresh();
    } catch (error: AxiosError | any) {
      toast.error(error.response.data.message);
    }
  };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handlePublish = async (row: any) => {
    try {
      const payload = {
        game_id: row?.GameID,
        customer_id: row?.CustomerID,
        is_active: true,

        poll_type: row?.PollType,
        question: row?.Question,
        poll_background: row?.PollBackgroundImage,
        title: row?.Title,
        options: row?.Options,
        total_vote: row?.TotalVotes,
        poll_id: row?.ID,
      };
      const res = await HttpService.post(
        APIRoutes.PublishPoll.replace(":id", row?.ID),
        payload
      );

      handleRefresh();
    } catch (error: AxiosError | any) {
      toast.error(error.response.data.message);
    }
  };
  const handelDeleteError = async (row: any) => {
    const payload = {
      game_id: row?.GameID,
      customer_id: row?.CustomerID,
      is_active: false,
      open: false,

      poll_type: row?.PollType,
      question: row?.Question,
      poll_background: row?.PollBackgroundImage,
      title: row?.Title,
      options: row?.Options,
    };
    try {
      const res = await HttpService.post(
        APIRoutes.DeletePoll.replace(":id", row?.ID),
        payload
      );
      handleRefresh();
    } catch (error: AxiosError | any) {
      toast.error(error.response.data.message);
    }
  };
  return (
    <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-start" }}>
      <button
        onClick={() => {
          if (data?.IsActive) {
            handleUnpublish(data);
          } else {
            handlePublish(data);
          }
        }}
        style={{
          cursor: "pointer",
          width: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className={configData.buttonCommonClass}
      >
        {!!data?.IsSchedule && <ScheduleIcon sx={{ color: "#7CFC00" }} />}
        {data?.IsActive ? "Move to Trash" : "Make Available"}
      </button>{" "}
      <button
        onClick={() => navigate(PageRoutes.EditPolls.replace(":id", data?.ID))}
        style={{
          cursor: "pointer",
          width: "50px",
        }}
        className={configData.buttonCommonClass}
      >
        <EditIcon />
      </button>
      <button
        onClick={() => handelDeleteError(data)}
        style={{
          cursor: "pointer",
          width: "50px",
        }}
        className={configData.buttonCommonClass}
      >
        <Delete />
      </button>
    </Box>
  );
};
export default StatusBox;
